let bannerList=[
    {
        id:1,
        src:"https://assets-in.bmscdn.com/promotions/cms/creatives/1683631934298_sunburngoadesktop.jpg"
    },
    {
        id:2,
        src:"https://assets-in.bmscdn.com/promotions/cms/creatives/1682617779318_webbannernpa.jpg"
    },
    {
        id:3,
        src:"https://assets-in.bmscdn.com/promotions/cms/creatives/1684155045598_gispykingsdesktop.jpeg"
    },
    {
        id:4,
        src:"https://assets-in.bmscdn.com/promotions/cms/creatives/1680083241797_rewardsweb.jpg"
    }
]
export default bannerList; 